import {
	Org,
	OrgsApi,
	Product,
	ProductsApi,
	SearchApi,
	SearchResults,
	Site,
	SitesApi,
	User,
	UsersApi,
} from '@/api';

export class SearchService {
	private searchApi: SearchApi = new SearchApi();

	constructor() {}

	public async search(searchValue: string): Promise<SearchResults> {
		const searchResults: SearchResults = (await this.searchApi.search(searchValue))?.data ?? {};
		searchResults.orgs = searchResults.orgs ?? [];
		searchResults.sites = searchResults.sites ?? [];
		searchResults.users = searchResults.users ?? [];
		searchResults.products = searchResults.products ?? [];
		searchResults.transceivers = searchResults.transceivers ?? [];
		searchResults.sensors = searchResults.sensors ?? [];
		searchResults.gateways = searchResults.gateways ?? [];
		searchResults.nodes = searchResults.nodes ?? [];
		return searchResults;
	}
}
